export const faqsdata = [
    {
        heading: 'Why should choose Vidom?',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit nulla pretium ultrices enim at. Sit egestas aliquet sodales amet, sed nam maecenas. Lorem ipsum dolor sit amet,'
    },
    {
        heading: 'Why should choose Vidom?',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit nulla pretium ultrices enim at. Sit egestas aliquet sodales amet, sed nam maecenas. Lorem ipsum dolor sit amet,'
    },
    {
        heading: 'Why should choose Vidom?',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit nulla pretium ultrices enim at. Sit egestas aliquet sodales amet, sed nam maecenas. Lorem ipsum dolor sit amet,'
    },
    {
        heading: 'Why should choose Vidom?',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi velit nulla pretium ultrices enim at. Sit egestas aliquet sodales amet, sed nam maecenas. Lorem ipsum dolor sit amet,'
    },
]